import { mittweidaFields } from 'mittweida/inquiry/fields';
import { fieldValidators } from 'modules/Inquiry/inquiryFieldValidation/customValidations';

export const otherFundingSectionValidationMap = {
  [mittweidaFields.fundingDetailsPage.otherFundingSection.description]: fieldValidators
    .string()
    .required()
    .max(5000),
};
